<template>
    <div id="corpo-card" :class="`card-inteiro ${selecionado? 'card-marcado' : ''}`" @click="cliqueCard()">
        <div class="icone-exclamacao">
            <v-icon size="30" class="orange--text">
                fas fa-exclamation-triangle
            </v-icon>
        </div>

        <v-tooltip class="icone-selecao" top>
            <template slot="activator">
                <v-icon v-if="selecionado" size="14" class="ma-2 primary--text" id="selecionado">
                    fas fa-check-circle
                </v-icon>
                <v-icon v-else size="14" class="ma-2 primary--text">
                    far fa-circle
                </v-icon>
            </template>
            <span v-if="selecionado">
                Selecionado
            </span>
            <span v-else>
                Selecionar
            </span>
        </v-tooltip>

        <div class="texto-card">
            <p>
                <strong>Processo:</strong> {{ requisicao.numeroProcesso }}
            </p>
            <v-layout row>
                <p><strong>Url:&nbsp;</strong></p>
                <expansao-texto :tamanho=25 :texto="removerPrefixoUrl(requisicao.urlEndpoint)"/>
            </v-layout>
            <p class="mb-1">
                <strong>Método:</strong>
                {{ requisicao.method }}
            </p>
            <span class="situacao-requisicao red lighten-1">
                {{ requisicao.situacao | cdEnum(situacoesRequisicao )}}
                -
                {{requisicao.responseStatusCode}}
            </span>
        </div>
    </div>
</template>

<script>
import {tiposCompraDireta, situacoesRequisicao} from '@/core/constants'

export default {
    name: 'RequisicoesComErroCarrosselCard',
    props: {
        requisicao:{
            type: Object,
            default: null
        },
        baseUrl:{
            type: String,
            default: ''
        },
        selecionado:{
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            situacoesRequisicao,
            tiposCompraDireta,
        }
    },
    methods: {
        cliqueCard(){
            if(this.selecionado) {
                this.desmarcarCardRequisicao()
            }else {
                this.marcarCardRequisicao()
            }
        },
        marcarCardRequisicao(){
            this.$emit('marcarCard', this.requisicao)
        },
        desmarcarCardRequisicao(){
            this.$emit('desmarcarCard', this.requisicao)
        },
        removerPrefixoUrl(url){
            return url.replace(this.baseUrl, '')
        }
    }
}
</script>

<style scoped lang="stylus">
    .card-inteiro
        width 100%
        display flex

        div[role="listitem"]
            display none

    .icone-exclamacao
        margin auto 20px

    .texto-card
        color grey
        font-size 12px
        padding 10px 10px 10px 0
        width 100%

    .situacao-requisicao
        color #fff
        padding 2px 5px
        border-radius 2px

    .icone-selecao
        position absolute
        right 0
        z-index 1

    .card-marcado
        box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
</style>
